import { ErrorLogTab } from "@/components/settings/ErrorLogTab";

export function SettingsErrorLogPage() {
  return <ErrorLogTab />;
}
